import { getAudioUrl } from 'src/utils/cdn';

export const beep = new Audio(getAudioUrl('beep.mp3'));
export const clock = new Audio(getAudioUrl('wait4_part.mp3'));
export const next = new Audio(getAudioUrl('next.wav'));
export const ready = new Audio(getAudioUrl('ready.mp3'));
export const typingClick = new Audio(getAudioUrl('typing_click.wav'));
export const oops = new Audio(getAudioUrl('oops.wav'));
export const perfect = new Audio(getAudioUrl('perfect.mp3'));
export const good = new Audio(getAudioUrl('good.mp3'));
export const thatsOk = new Audio(getAudioUrl('that_s_ok.mp3'));
export const tryAgain = new Audio(getAudioUrl('try_again.mp3'));
export const homeBackground = new Audio(getAudioUrl('home_background.mp3'));
export const HOME_BACKGROUND_STORAGE_KEY = 'segim_home_background_enabled';
export const HOME_BACKGROUND_SETTING_EVENT = 'segimHomeBackgroundSettingChanged';

homeBackground.loop = true;
homeBackground.volume = 0.5;
clock.volume = 0.25;

const getSafeLocalStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

export const isHomeBackgroundEnabled = () => {
  const storage = getSafeLocalStorage();

  if (!storage) {
    return true;
  }

  let storedValue = null;

  try {
    storedValue = storage.getItem(HOME_BACKGROUND_STORAGE_KEY);
  } catch (error) {
    return true;
  }

  if (storedValue === null) {
    return true;
  }

  return storedValue === 'true';
};

export const pauseHomeBackground = ({ reset = false } = {}) => {
  homeBackground.pause();

  if (reset) {
    homeBackground.currentTime = 0;
  }
};

export const playHomeBackground = ({ restart = false } = {}) => {
  if (!isHomeBackgroundEnabled()) {
    pauseHomeBackground({ reset: restart });
    return;
  }

  if (restart) {
    homeBackground.currentTime = 0;
  }

  if (homeBackground.paused) {
    const playPromise = homeBackground.play();

    if (playPromise && playPromise.catch) {
      playPromise.catch(() => {});
    }
  }
};

export const syncHomeBackgroundPlayback = ({ restart = false } = {}) => {
  if (isHomeBackgroundEnabled()) {
    playHomeBackground({ restart });
  } else {
    pauseHomeBackground({ reset: restart });
  }
};

export const setHomeBackgroundEnabled = (isEnabled) => {
  const storage = getSafeLocalStorage();

  if (storage) {
    try {
      storage.setItem(
        HOME_BACKGROUND_STORAGE_KEY,
        String(isEnabled)
      );
    } catch (error) {
      // Ignore storage write failures in restricted mobile webviews.
    }
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(HOME_BACKGROUND_SETTING_EVENT));
  }

  if (isEnabled) {
    playHomeBackground();
  } else {
    pauseHomeBackground({ reset: true });
  }
};

/**
 * HTMLMediaElement 는 참조만 끊어서는 디코더와 버퍼가 곧바로 반환되지 않는다.
 * 재생을 멈추고 src 를 비운 뒤 load() 를 호출해 명시적으로 해제한다.
 */
export const releaseAudio = (audio) => {
  if (!audio) {
    return;
  }

  try {
    audio.pause();
    audio.onended = null;
    audio.removeAttribute('src');
    audio.load();
  } catch (error) {
    // 이미 해제된 엘리먼트는 무시한다.
  }
};

/**
 * 문항 목록이 들고 있는 오디오 엘리먼트를 일괄 해제한다.
 * 문항 오디오는 모듈을 열 때마다 문항 수만큼 new Audio() 로 생성되므로
 * 모듈을 떠날 때 반드시 해제해야 한다.
 */
export const releaseQuestionsAudio = (questions) => {
  if (!Array.isArray(questions)) {
    return;
  }

  questions.forEach((question) => question && releaseAudio(question.audio));
};

export const playTypingClick = () => {
  typingClick.pause();
  typingClick.currentTime = 0;
  typingClick.play();
};
